import { AppliancesTableStyle } from "@components/appliances/appliancesTable/appliancesTableStyle";
import styled from "styled-components";

export const PeriodApplianceTableStyle = styled(AppliancesTableStyle)`
    .subbar {
        display: flex;
        justify-content: space-between;
    }
`;
